import { useEffect, useState } from "react";
import "../styles/style.css";
import ServiceCard from "./Cards/Services-card";
import services from "../Data/services.json";
import Title from "./Title";
import Button from "./Buttons";

import { useTranslation } from "react-i18next"

export default function SectionSix() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
    const [showAll, setShowAll] = useState(false);


    const { t } = useTranslation();

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 992;

            setIsMobile(mobile);

            if (!mobile) {
                setShowAll(false);
            }
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const visibleServices =
        isMobile && !showAll ? services.slice(0, 3) : services;

    return (
        <section className="section sec-6">

            <Title id="services" title={t("title-services.text")} />

            <div data-aos="fade-right" className="container container-6">

                {visibleServices.map((e) => (
                    <ServiceCard
                        key={e.card}
                        title={t(`services.card${e.card}.title`)}
                        paragraph={t(`services.card${e.card}.paragraph`)}
                        icon={e.icon}
                    />
                ))}

                {isMobile && (
                    <Button
                        className="btn-click btn-view"
                        id="btn-view"
                        title={showAll ? t("show-less.text") : t("view-more.text")}
                        onClick={() => setShowAll((prev) => !prev)}
                    />
                )}

            </div>

        </section>
    );
}